<template>
  <v-dialog v-model="internalShowDialog" max-width="65rem">
    <v-card>
      <v-card-title>
        <span class="headline">Delete Container Options</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-alert>
              Are you sure you want to delete the container options?
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-end" style="gap:16px">
            <v-btn @click="closeDialog">Cancel</v-btn>
            <v-btn color="error" @click="confirmDelete">Delete</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    selectedOptions: Object
  },
  computed: {
    internalShowDialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    closeDialog () {
      this.internalShowDialog = false
    },
    confirmDelete () {
      this.$emit('delete', this.selectedOptions)
      this.closeDialog()
    }
  }
}
</script>
